import { render, staticRenderFns } from "./score-ponderation.html?vue&type=template&id=01dee6c5&scoped=true&external"
import script from "./score-ponderation.js?vue&type=script&lang=js&external"
export * from "./score-ponderation.js?vue&type=script&lang=js&external"
import style0 from "./score-ponderation.scss?vue&type=style&index=0&id=01dee6c5&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01dee6c5",
  null
  
)

export default component.exports